const disableable = ({ disabled }) => disabled ? 'not-allowed' : 'pointer'

const cursor = props => `
  cursor: ${disableable(props)};
`
export default cursor
